import { IChart, IChartInfo } from "../interfaces/chart.interface";

export function convertChartData(
  data: IChartInfo,
  label: string = ""
): IChart[] {
  let dailyLabelsArr: string[] = [],
    weeklyLabelsArr: string[] = [],
    monthlyLabelsArr: string[] = [];
  let dailyDatasetArr: number[] = [],
    weeklyDatasetArr: number[] = [],
    monthlyDatasetArr: number[] = [];

  data.DAILY.dataset.forEach((res) => {
    dailyLabelsArr.push(res.label);
    dailyDatasetArr.push(res.value);
  });
  data.WEEKLY.dataset.forEach((res) => {
    weeklyLabelsArr.push(res.label);
    weeklyDatasetArr.push(res.value);
  });
  data.MONTHLY.dataset.forEach((res) => {
    monthlyLabelsArr.push(res.label);
    monthlyDatasetArr.push(res.value);
  });

  return [
    {
      id: "daily",
      title: "Daily",
      data: {
        labels: dailyLabelsArr,
        datasets: [
          {
            label: label,
            fill: false,
            borderColor: "#3FC79A",
            borderWidth: 1,
            pointRadius: 2,
            data: dailyDatasetArr,
          },
        ],
      },
    },
    {
      id: "weekly",
      title: "Weekly",
      data: {
        labels: weeklyLabelsArr,
        datasets: [
          {
            label: label,
            fill: false,
            borderColor: "#3FC79A",
            borderWidth: 1,
            pointRadius: 2,
            data: weeklyDatasetArr,
          },
        ],
      },
    },
    {
      id: "monthly",
      title: "Monthly",
      data: {
        labels: monthlyLabelsArr,
        datasets: [
          {
            label: label,
            fill: false,
            borderColor: "#3FC79A",
            borderWidth: 1,
            pointRadius: 2,
            data: monthlyDatasetArr,
          },
        ],
      },
    },
  ];
}
